import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks';

const formReducer = (state, event) => ({
	...state,
	[event.name]: event.value,
});

function AuthErrorAlert({ error }) {
	if (!error) return null;

	return (
		<div className="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
			{error}
		</div>
	);
}

AuthErrorAlert.propTypes = {
	error: PropTypes.string,
};

AuthErrorAlert.defaultProps = {
	error: null,
};

function Auth() {
	const navigate = useNavigate();
	const { error, redirectTo, handleLogin, isLoading } = useAuth();
	const [formData, setFormData] = useReducer(formReducer, {});

	if (redirectTo) {
		return navigate(redirectTo, { replace: true });
	}

	const onChange = (e) => {
		setFormData({ name: e.target.name, value: e.target.value });
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const { username, password } = formData;
		handleLogin(username, password, '/dashboardCard');
	};

	return (
		<main className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-sm">
				<div className="text-center mb-8">
					<span className="font-montserrat font-bold text-3xl text-cr-green">
						CR Flow
					</span>
				</div>

				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
					<h1 className="text-lg font-semibold text-gray-800 mb-6">Sign in</h1>

					<AuthErrorAlert error={error} />

					<form onSubmit={onSubmit} className="space-y-4">
						<label
							className="block text-sm font-medium text-gray-700"
							htmlFor="username"
						>
							Username
							<input
								id="username"
								type="text"
								name="username"
								className="mt-1 w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-cr-green focus:border-transparent transition"
								placeholder="Username"
								required
								onChange={onChange}
								autoComplete="username"
							/>
						</label>

						<label
							className="block text-sm font-medium text-gray-700"
							htmlFor="password"
						>
							Password
							<input
								id="password"
								type="password"
								name="password"
								className="mt-1 w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-cr-green focus:border-transparent transition"
								placeholder="Password"
								required
								onChange={onChange}
								autoComplete="current-password"
							/>
						</label>

						<button
							type="submit"
							disabled={isLoading}
							className="w-full bg-cr-green hover:bg-green-600 text-white font-semibold py-2 px-4 rounded transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
						>
							{isLoading ? 'Signing in…' : 'Sign in'}
						</button>
					</form>
				</div>
			</div>
		</main>
	);
}

export default Auth;
